<template>
    <div>
        <div class="titleCont"><h1>{{base.title}}</h1></div>
        <div class="nameCont"><span>发布人：{{base.name}}</span> <span>发布时间：{{base.auditTime}}</span></div>
        <div class="contentT" v-html="base.content">{{base.content}}</div>
    </div>
</template>

<script>
import {Toast} from 'vant';
import {MemberStyleDetails} from "@/api/dictionary";
export default {
  data() {
    return {
        base:[]
    };
  },
  components: {
    [Toast.name]:Toast
  },
  methods: {
      detail(id){
          MemberStyleDetails({id:id}).then(res=>{
              if(res.success){
                  this.base = res.result;
              }else {
                  Toast.fail("获取数据错误!");
                  this.$router.push({name:"memberStyle"})
              }
          });
      }
  },
  computed: {
      id(){
          return this.$route&&this.$route.query.id;
      }
  },
  mounted() {
      this.detail(this.id);
  }
}
</script>
<style scoped lang="less">
    .titleCont h1{ font-size: 22px; font-weight: bold; text-align: center; }
    .nameCont{ text-align: center; font-size:14px; margin-top: 20px; }
    .nameCont span{ margin: 0 10px; }
    .contentT{ margin-top: 20px; }
</style>